import { CompanyDetailPageTranslation } from 'locales/de/pages/Jobmarket/companyDetailPage';

const en: CompanyDetailPageTranslation = {
  noOffers: 'Unfortunately this company has no job offers at this time',
  openOffers: 'Open Offers',
  forbidden: 'You may only see your own company profile.',
  notActive: "Your company is currently inactive and can't be edited.",
  agreeToNewsletter: 'Agree to Newsletter',

  banCompany: {
    title: 'Ban {{name}}',
    description:
      'You are about to ban a company. Please provide your reasoning here. This information will be provided for the company.'
  },
  notAvailable: 'This company is currently not available',
  openFailed: 'Company could not be opened',
  notFound: 'Company could not be found',
  errorLoading: 'Company could not be loaded.',
  missingFields: {
    country: 'country',
    invoiceEmail: 'invoice email',
    taxIdAndNumber: 'vat number and tax number'
  },
  offerWarning: {
    title: 'Incomplete company profile',
    description: 'Unfortunately, the data in your company profile is incomplete.',
    emptyFields: 'The following fields must be filled in:',
    explanation: 'Therefore, you cannot create paid advertisements.',
    editCompanyButton: 'Edit company',
    createOfferButton: 'Nevertheless continue'
  },
  dialogs: {
    newsletterConfirmationTitle: 'Newsletter Confirmation',
    newsletterConfirmationText:
      'I hereby confirm my consent to receiving the job market newsletter.'
  }
};
export default en;
